import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffectiveIdentity } from '@/hooks/useEffectiveIdentity';
import { Loader2 } from 'lucide-react';

export function RoleBasedRedirect() {
  const navigate = useNavigate();
  const { loading, isAdmin, isProcurementManager, isProviderManager, isMAManager, isDepartmentManager, isQAManager, isTechApps, isTechInfrastructure, isCreativeManager } = useEffectiveIdentity();

  useEffect(() => {
    // Safety timeout: avoid getting stuck more than 4s
    const timer = setTimeout(() => {
      if (loading) {
        console.warn('[RoleBasedRedirect] Timeout - navigating to default');
        navigate('/task-manager', { replace: true });
      }
    }, 4000);

    return () => clearTimeout(timer);
  }, [loading, navigate]);

  useEffect(() => {
    // Wait for role to load before redirecting
    if (!loading) {
      let target = '/task-manager'; // Default for most roles
      
      if (isAdmin) {
        target = '/business-summary';
      } else if (isProcurementManager) {
        target = '/task-manager';
      } else if (isProviderManager) {
        target = '/task-manager';
      } else if (isMAManager) {
        target = '/task-manager';
      } else if (isQAManager) {
        target = '/task-manager';
      } else if (isTechApps || isTechInfrastructure) {
        target = '/task-manager';
      } else if (isCreativeManager) {
        target = '/task-manager';
      } else if (isDepartmentManager) {
        target = '/performance-summary';
      }
      
      console.log('[RoleBasedRedirect] Redirecting', { 
        isAdmin, 
        isProcurementManager,
        isProviderManager,
        isMAManager,
        isQAManager,
        isTechApps,
        isTechInfrastructure,
        isCreativeManager,
        isDepartmentManager,
        loading, 
        target 
      });
      navigate(target, { replace: true });
    }
  }, [loading, isAdmin, isProcurementManager, isProviderManager, isMAManager, isQAManager, isTechApps, isTechInfrastructure, isCreativeManager, isDepartmentManager, navigate]);

  // Show loading spinner while role is being determined
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto" />
        <p className="text-muted-foreground">Loading your workspace...</p>
      </div>
    </div>
  );
}
